export default __webpack_public_path__ + "static/media/Portfolio.1e8f8081.png";